import { Redirect } from 'react-router-dom';
import { Permissions } from '../../shared/auth/constants/permissions';
import { useHasPermission } from '../Session';
import BasicLayout from '../layouts/BasicLayout';
import ActivityHistory from '../pages/ActivityHistory';
import { DownloadActivityHistoryFileProvider } from '../pages/ActivityHistory/components';

const ActivityHistoryRoute = () => {
    const canExportActivities = useHasPermission(Permissions.ACTIVITIES_LOG_EXPORT);

    if (!canExportActivities) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <DownloadActivityHistoryFileProvider>
                {downloadFile => <ActivityHistory downloadFile={downloadFile} />}
            </DownloadActivityHistoryFileProvider>
        </BasicLayout>
    );
};

export default ActivityHistoryRoute;
